import clsx from 'clsx'
import React, { FC, useState } from 'react'
import Modal from 'react-modal';
import { useLayout } from '../../../core/LayoutProvider'
import { usePageData } from '../../../core/PageData'
import CycleMarker from '../../../../../app/pages/customer/components/steps/CycleMarker'
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../../setup';
import { TestJournalModal } from '../../../../../app/pages/customer/components/TestJournalModal';
import { useLocation, useParams } from 'react-router-dom';

const DefaultTitle: FC = () => {
  const { id } = useParams<any>();
  const { pageTitle, pageDescription } = usePageData()
  const { config, classes } = useLayout()
  const [journalmodalIsOpen, setJournalIsOpen] = useState(false);
  const location = useLocation();

  const serverStatus: any = useSelector<RootState>(({ customer }) => customer.serverStatus, shallowEqual) as any;

  function openTestJournalModal() {
    setJournalIsOpen(true);
  }

  function closeTestJournalModal() {
    setJournalIsOpen(false);
  }

  const handleClickMark = () => {
    openTestJournalModal();
  }


  const customStyles = {
    content: {
      backgroundColor: 'transparent',
      display: 'flex',
      border: 'none',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: '100%',
      minHeight: '100%',
      padding: 0
    },
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.4)',
      zIndex: 920
    }
  };

  // const { currentStep } = useAuth();
  return (

    <div
      id='kt_page_title'
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx('page-title d-flex', classes.pageTitle.join(' '))}
    >
      {/* begin::Title */}
      {pageTitle && (
        <h1 className='d-flex align-items-center text-dark fw-bolder my-1 fs-3'>
          {
            !location.pathname.includes("maintenance") &&
            <>
              <CycleMarker
                handleClick={handleClickMark}
                serverStatus={serverStatus}
              />
              &nbsp;  &nbsp;
            </>
          }
          {pageTitle}
          {pageDescription && config.pageTitle && config.pageTitle.description && (
            <>
              <span className='h-20px border-gray-200 border-start ms-3 mx-2'></span>
              <small className='text-muted fs-7 fw-bold my-1 ms-1'>{pageDescription}</small>
            </>
          )}
        </h1>
      )}
      {/* end::Title */}

      <Modal
        isOpen={journalmodalIsOpen}
        onRequestClose={closeTestJournalModal}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="Edit"
      >
        <TestJournalModal
          id={id}
          options={[]}
          closeModal={closeTestJournalModal}
        />
      </Modal>
    </div>
  )
}

export { DefaultTitle }
